module.exports = __webpack_public_path__ + "img/PayPal-ClientID.5158d6cb.jpg";